<aside class="side-menu-wrapper">
  <nav class="menu-sidebar d-flex shadow-right">
    <div [hidden]="!isMenuShown" class="menu-sidebar-wrap shadow-right ">
      <ul class="side-menu-list ">
        <li [routerLinkActive]="['active']" class="cursor active" (click)="menuChange(menuItem?.nav)"
          *ngFor="let menuItem of leftMainMenuList; let i = index">
          <span><a [class.disabled]="disableMenu ? true : null"
              [ngClass]="{'selectedModule':selectedModule?.code===menuItem?.code}">
              <img [src]="(selectedModule?.code===menuItem?.code)?menuItem?.activeImgUrl:menuItem?.inactiveImgUrl"
                class="h-30" alt="menuItem?.name"><span class="menu-label-spacing">{{ menuItem?.name |
                titlecase}}</span></a>
          </span>
          <span class="tooltiptext" [class.disabled]="disableMenu ? true : null" [routerLink]="[menuItem?.code]"></span>
        </li>
      </ul>
    </div>
  </nav>
</aside>